import LongitudinalPage from './LongitudinalPage'

export default LongitudinalPage
